import {createSvgIcon} from '../create-svg-icon';

export const ViewCarouselIcon = createSvgIcon(
  <path d="M2 7h4v10H2V7zm5 12h10V5H7v14zM9 7h6v10H9V7zm9 0h4v10h-4V7z" />
, 'ViewCarouselOutlined');
